import { useTranslation } from 'react-i18next';
import CollapsibleWrapper, { Panel } from '../../../../../components/wrappers/CollapsibleWrapper';
import ExportExcel from '../../shared/ExportExcel';
import ImportExcel from '../../shared/ImportExcel';
import DisplacementValueTable, { useDisplacementExcelHandler } from './DisplacementValueTable';

const mappedHeaders = {
    'Engine Displacement Min.*': 'min',
    'Engine Displacement Max.*': 'max',
    'Tax*': 'value',
};

export type FuelTaxTableProps = {
    disabled?: boolean;
};

const settingsKey = 'licenseAndFuelTax.fuelTable';

const FuelTaxTable = ({ disabled = false }: FuelTaxTableProps) => {
    const { t } = useTranslation(['financeProductDetails']);
    const { onImport, onExport } = useDisplacementExcelHandler(
        settingsKey,
        mappedHeaders,
        t('financeProductDetails:tables.ucclLeasing.fuelTax')
    );

    // Initial values has been set it "FinanceProductInitializer"
    // With it's the default values
    // So left with rendering

    return (
        <CollapsibleWrapper defaultActiveKey={['fuelTax']}>
            <Panel key="fuelTax" header={t('financeProductDetails:tables.ucclLeasing.fuelTax')}>
                <DisplacementValueTable
                    disabled={disabled}
                    labelKey={t('financeProductDetails:tables.ucclLeasing.columnTitles.engineDisplacement')}
                    settingsKey={settingsKey}
                    valueKey={t('financeProductDetails:tables.ucclLeasing.columnTitles.fuelTaxValue')}
                />
            </Panel>
            <ImportExcel
                mappedHeaders={mappedHeaders}
                onImport={onImport}
                title={t('financeProductDetails:importModal.titles.ucclLeasing.fuelTax')}
            />
            <ExportExcel onClick={onExport} />
        </CollapsibleWrapper>
    );
};

export default FuelTaxTable;
